import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items"];
import React from 'react';
import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { styledWithTheme } from "../../context";
import { pickDataProps, withTestAttributes } from "../../utils";
import { jsx as ___EmotionJSX } from "@emotion/core";
var Ul = styledWithTheme('ul')({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  display: 'flex'
});
var Li = styledWithTheme('li')({
  display: 'flex'
});

var PageHeaderListWithoutDocs = function PageHeaderListWithoutDocs(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      forwardedProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(Ul, _extends({
    role: "list"
  }, pickDataProps(forwardedProps)), items.map(function (item, index) {
    return ___EmotionJSX(Li, {
      key: index
    }, item);
  }));
};

var PageHeaderListWithDocs = describe(PageHeaderListWithoutDocs).description('List element containing page header contents and placing them semantically in a list.');
PageHeaderListWithDocs.propTypes = {
  children: PropTypes.node.description('Content of the list.')
};
export var PageHeaderList = withTestAttributes({
  component: 'StencilPageHeaderList'
})(PageHeaderListWithDocs);
PageHeaderList.displayName = 'PageHeaderList';